import {
  Activity,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  BadgeCheck,
  Bell,
  BellOff,
  Blocks,
  BookOpen,
  Briefcase,
  Building,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarDays,
  CalendarX,
  Car,
  ChartBar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUpDown,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleHelp,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cloud,
  CloudCheck,
  CloudOff,
  CloudUpload,
  Command,
  Construction,
  Copy,
  CornerDownLeft,
  Cpu,
  Database,
  Download,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  Files,
  FileText,
  Filter,
  FingerprintPattern,
  Flame,
  Folder,
  FolderKanban,
  FolderTree,
  Gauge,
  GitCompare,
  Globe,
  GraduationCap,
  Grid2x2,
  Hammer,
  HardHat,
  Headset,
  HeartPulse,
  History,
  House,
  Image,
  Inbox,
  Info,
  KeyRound,
  Landmark,
  Languages,
  Laptop,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  Link,
  List,
  ListChecks,
  LoaderCircle,
  LocateFixed,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  Menu,
  MessageSquare,
  Minus,
  Monitor,
  Moon,
  Network,
  Package,
  Palette,
  PanelLeft,
  PanelLeftClose,
  Pencil,
  Phone,
  Plug,
  Plus,
  Printer,
  Receipt,
  Repeat,
  RefreshCw,
  RotateCcw,
  Router,
  Ruler,
  Save,
  Scale,
  ScrollText,
  Search,
  Server,
  Settings,
  Share2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingCart,
  SlidersHorizontal,
  Sparkles,
  SquareKanban,
  Sun,
  SunMoon,
  ThumbsUp,
  Ticket,
  Timer,
  Trash2,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Truck,
  type LucideIcon,
  Unlink,
  Upload,
  User,
  UserCog,
  UserMinus,
  UserPlus,
  UserRound,
  Users,
  Video,
  Wallet,
  Warehouse,
  Wifi,
  WifiOff,
  Wrench,
  X,
  Camera,
  Scan,
  ZoomIn,
  ZoomOut,
} from 'lucide-react';
import {
  Bold,
  Braces,
  Italic,
  ListOrdered,
  Redo2,
  SeparatorHorizontal,
  Table,
  TextAlignCenter,
  TextAlignEnd,
  TextAlignJustify,
  TextAlignStart,
  Underline,
  Undo2,
} from 'lucide-react';
import { cn } from '../lib/cn';

/**
 * The only icon set of the app (Lucide). Module icons in manifests use the names of
 * `ICON_NAMES` from @nexus/core, all of which exist here; the rest serves the components.
 */
export const ICONS = {
  activity: Activity,
  archive: Archive,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-up-down': ArrowUpDown,
  'badge-check': BadgeCheck,
  bell: Bell,
  'bell-off': BellOff,
  blocks: Blocks,
  'book-open': BookOpen,
  briefcase: Briefcase,
  building: Building,
  'building-2': Building2,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'calendar-days': CalendarDays,
  'calendar-x': CalendarX,
  car: Car,
  'chart-bar': ChartBar,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevrons-up-down': ChevronsUpDown,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-help': CircleHelp,
  'circle-x': CircleX,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  clock: Clock,
  cloud: Cloud,
  'cloud-check': CloudCheck,
  'cloud-off': CloudOff,
  'cloud-upload': CloudUpload,
  command: Command,
  construction: Construction,
  copy: Copy,
  'corner-down-left': CornerDownLeft,
  cpu: Cpu,
  database: Database,
  download: Download,
  ellipsis: Ellipsis,
  'ellipsis-vertical': EllipsisVertical,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-off': EyeOff,
  file: File,
  'file-text': FileText,
  files: Files,
  filter: Filter,
  fingerprint: FingerprintPattern,
  flame: Flame,
  folder: Folder,
  'folder-kanban': FolderKanban,
  'folder-tree': FolderTree,
  gauge: Gauge,
  'git-compare': GitCompare,
  globe: Globe,
  'graduation-cap': GraduationCap,
  'grid-2x2': Grid2x2,
  hammer: Hammer,
  'hard-hat': HardHat,
  headset: Headset,
  'heart-pulse': HeartPulse,
  history: History,
  house: House,
  image: Image,
  inbox: Inbox,
  info: Info,
  'key-round': KeyRound,
  landmark: Landmark,
  languages: Languages,
  laptop: Laptop,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  'life-buoy': LifeBuoy,
  link: Link,
  list: List,
  'list-checks': ListChecks,
  'loader-circle': LoaderCircle,
  locate: LocateFixed,
  lock: Lock,
  'lock-open': LockOpen,
  'log-in': LogIn,
  'log-out': LogOut,
  mail: Mail,
  map: Map,
  'map-pin': MapPin,
  menu: Menu,
  'message-square': MessageSquare,
  minus: Minus,
  monitor: Monitor,
  moon: Moon,
  network: Network,
  package: Package,
  palette: Palette,
  'panel-left': PanelLeft,
  'panel-left-close': PanelLeftClose,
  pencil: Pencil,
  phone: Phone,
  plug: Plug,
  plus: Plus,
  printer: Printer,
  receipt: Receipt,
  repeat: Repeat,
  'refresh-cw': RefreshCw,
  'rotate-ccw': RotateCcw,
  router: Router,
  ruler: Ruler,
  save: Save,
  scale: Scale,
  'scroll-text': ScrollText,
  search: Search,
  server: Server,
  settings: Settings,
  'share-2': Share2,
  shield: Shield,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  'shopping-cart': ShoppingCart,
  'sliders-horizontal': SlidersHorizontal,
  sparkles: Sparkles,
  'square-kanban': SquareKanban,
  sun: Sun,
  'sun-moon': SunMoon,
  'thumbs-up': ThumbsUp,
  ticket: Ticket,
  timer: Timer,
  'trash-2': Trash2,
  'trending-down': TrendingDown,
  'trending-up': TrendingUp,
  'triangle-alert': TriangleAlert,
  truck: Truck,
  unlink: Unlink,
  upload: Upload,
  user: User,
  'user-cog': UserCog,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
  'user-round': UserRound,
  users: Users,
  video: Video,
  wallet: Wallet,
  warehouse: Warehouse,
  wifi: Wifi,
  'wifi-off': WifiOff,
  wrench: Wrench,
  x: X,
  camera: Camera,
  scan: Scan,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  // Toolbar of the rich text editor.
  bold: Bold,
  braces: Braces,
  italic: Italic,
  'list-ordered': ListOrdered,
  'redo-2': Redo2,
  'separator-horizontal': SeparatorHorizontal,
  table: Table,
  'text-align-center': TextAlignCenter,
  'text-align-end': TextAlignEnd,
  'text-align-justify': TextAlignJustify,
  'text-align-start': TextAlignStart,
  underline: Underline,
  'undo-2': Undo2,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export interface IconProps {
  name: IconName;
  className?: string;
  /** Icons are decorative by default; a label makes them an image for screen readers. */
  label?: string;
}

export function Icon({ name, className, label }: IconProps) {
  const Component = ICONS[name];
  return (
    <Component
      className={cn('size-4 shrink-0', className)}
      strokeWidth={1.75}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    />
  );
}
